<script lang="ts">
  function flashOutline(elem) {
    let style = "3px dashed darkgrey";
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0, // Ensure the element is fully visible
    };
    function handleIntersection(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          elem.style.outline = style;
          setTimeout(() => {
            elem.style.outline = "none";
            setTimeout(() => {
              elem.style.outline = style;
              setTimeout(() => {
                elem.style.outline = "none";
              }, 500);
            }, 500);
          }, 500);
          observer.disconnect(); // Disconnect the observer once the element has been fully flashed
        }
      });
    }
    const observer = new IntersectionObserver(
      handleIntersection,
      observerOptions
    );
    observer.observe(elem);
  }

  function scrollToMiddle(id: any) {
    const elem = document.getElementById(id);
    if (elem) {
      const rect = elem.getBoundingClientRect();
      const offset = window.scrollY || document.documentElement.scrollTop;
      const targetPosition =
        rect.top + offset - window.innerHeight / 2 + rect.height / 2;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    }
  }

  function outlineInputText() {
    const elem = document.getElementById("input-textarea");
    flashOutline(elem);
    scrollToMiddle("input-textarea");
  }
</script>

<div id="instructions">
  <h3 style="text-align: center;">Instructions</h3>
  <ol class="list note" type="1">
    <li>
      Enter your text into the <a
        href="#_"
        on:click={outlineInputText}
        style="text-decoration: none; color:grey; font-weight: bold;">textbox</a
      > below!
    </li>
    <li>
      Click <a
        href="#_"
        style="text-decoration: none; font-weight: bold; color:#5bc789">Cloak</a
      > to cloak your text, making it undetectable by AI-detectors!
    </li>
    <li>
      Click <a
        href="#_"
        style="text-decoration:none;font-weight:bold;color:skyblue;"
        >Un-Cloak</a
      > to deobfuscate your entire text, allowing AI-detectors to detect any AI-generated
      content!
    </li>
    <li>
      To check the reliability for yourself, use the <a
        href="#_"
        style="text-decoration:none;font-weight:bold;color:#3b82f6;">AI Check</a
      > button to see the total percentage of AI-generated content in your text!
    </li>
    <li>
      After you've highlighted a sentence, click <a
        href="#_"
        style="text-decoration:none;font-weight:bold;color:red;">Paraphrase</a
      > to get three different versions!
    </li>
    <li>
      Highlight a single word and click <a
        href="#_"
        style="text-decoration:none;font-weight:bold;color:darkorange"
        >Synonym</a
      > to see words with similar meanings to your selected text!
    </li>
  </ol>
</div>
